import { useContext } from 'react';
import { RolesContext } from 'contexts/rolesContext/RolesContext';

export const useRolesContext = () => {
	return useContext(RolesContext);
};
